import React from 'react';

import { CreateFromTemplateLoader } from '@confluence/create-from-template';

export const CreateFromTemplateHandler = ({
	macroDefaultProps,
	cloudId,
	userId,
	ssrButtonLabel,
}: {
	macroDefaultProps: any;
	cloudId: any;
	userId: any;
	ssrButtonLabel: any;
}): React.JSX.Element => (
	<CreateFromTemplateLoader
		userId={userId}
		cloudId={cloudId}
		macroDefaultProps={macroDefaultProps}
		ssrButtonLabel={ssrButtonLabel}
	/>
);
